module.exports = __webpack_public_path__ + "04_mole.9e0b5a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/04_mole.png
// module id = 5NFU
// module chunks = 0